import { render } from "./appDownload.vue?vue&type=template&id=1f90b7cb&scoped=true"
import script from "./appDownload.vue?vue&type=script&lang=js"
export * from "./appDownload.vue?vue&type=script&lang=js"

import "./appDownload.vue?vue&type=style&index=0&id=1f90b7cb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f90b7cb"]])

export default __exports__